import { render, staticRenderFns } from "./EventV2.vue?vue&type=template&id=1d799975&scoped=true&"
import script from "./EventV2.vue?vue&type=script&lang=js&"
export * from "./EventV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d799975",
  null
  
)

export default component.exports